require('javascripts/useek/conflict')
USeek.Conflict.prepare('MobileDetect')